<template>
    <div class="adverts">
        <div class="row">
            <div class="filter-secition">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">İlan Ara</label>
                        <div class="input-group">
                            <input class="form-control custom-input" type="text" placeholder="İlan Başlığı" v-model="search">
                            <span class="input-group-btn">
                                <a class="btn btn-primary" style="height: 45px;" @click="onFilter">
                                    <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Kategori</label>
                        <select class="form-control custom-input" v-model="category" @change="onFilter">
                            <option value="" selected hidden disabled>Seçiniz...</option>
                            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>İlan</th>
                                    <th>Kategori</th>
                                    <th>İşlemler</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td>{{ item.title }}</td>
                                    <td>{{ item.category.title }}</td>
                                    <td>
                                        <router-link :to="{ name: 'adverts.update', params: {id: item.id} }" class="btn btn-primary btn-xs">
                                             <span>Düzenle</span></router-link>
                                        /
                                        <button class="btn btn-danger btn-xs"> Sil</button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Pagination from '@/components/layouts/Pagination'

  export default {
    components: {Pagination},
    data() {
      return {
        tableName: 'İlanlar Tablosu',
        icon: 'fa fa-newspaper-o',
        tableDesc: '',
        api: 'adverts',
        items: [],
        category: '',
        categories: [],
        search: '',
        pagination: {
          'current_page': 1,
          'total': 0
        },
      }
    },
    mounted() {
      this.fetchPosts()
    },
    methods: {
      fetchPosts() {
        this.$Progress.start();
        this.axios.get(this.api, {
          params: {
            page: this.pagination.current_page,
            title: this.search,
            category: this.category
          }
        }).then(response => {
          this.pagination = response.data.pagination;
          this.items = response.data.data.data;
          this.categories = response.data.categories;
          this.$Progress.finish()
        })
      },
      onFilter() {
        this.pagination = {'current_page': 1};
        this.fetchPosts();
      },
    },
  }
</script>

<style scoped>

</style>
